var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.686,
    height: 24.685,
    viewBox: "0 0 23.686 24.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3057",
    "data-name": "Group 3057",
    transform: "translate(-17.57 -23.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M40.114,36.171a.724.724,0,0,1,0-.639l.921-1.883A2.143,2.143,0,0,0,40.11,30.8l-1.852-.983a.723.723,0,0,1-.376-.517l-.362-2.065A2.143,2.143,0,0,0,35.1,25.479l-2.076.294a.724.724,0,0,1-.608-.2l-1.507-1.458a2.143,2.143,0,0,0-2.992,0L26.41,25.575a.723.723,0,0,1-.608.2l-2.076-.294a2.143,2.143,0,0,0-2.421,1.759L20.944,29.3a.723.723,0,0,1-.376.517l-1.852.983a2.143,2.143,0,0,0-.925,2.846l.921,1.883a.723.723,0,0,1,0,.639l-.921,1.883a2.143,2.143,0,0,0,.925,2.846l1.852.983a.723.723,0,0,1,.376.517l.362,2.065a2.142,2.142,0,0,0,2.112,1.78,2.214,2.214,0,0,0,.308-.022l2.076-.294a.723.723,0,0,1,.608.2l1.507,1.458a2.143,2.143,0,0,0,2.992,0l1.507-1.458a.724.724,0,0,1,.608-.2l2.076.294a2.143,2.143,0,0,0,2.421-1.759l.362-2.065a.724.724,0,0,1,.376-.517L40.11,40.9a2.143,2.143,0,0,0,.925-2.846Zm-.671,3.471-1.852.983a2.138,2.138,0,0,0-1.111,1.529l-.362,2.065a.725.725,0,0,1-.819.6l-2.076-.294a2.137,2.137,0,0,0-1.8.584l-1.507,1.458a.725.725,0,0,1-1.012,0L27.4,45.1a2.136,2.136,0,0,0-1.491-.606,2.192,2.192,0,0,0-.306.022l-2.076.294a.725.725,0,0,1-.819-.6l-.362-2.065a2.138,2.138,0,0,0-1.111-1.529l-1.852-.982a.725.725,0,0,1-.313-.963l.921-1.883a2.138,2.138,0,0,0,0-1.89l-.921-1.883a.725.725,0,0,1,.313-.963l1.852-.982a2.138,2.138,0,0,0,1.111-1.529l.362-2.065a.725.725,0,0,1,.819-.6l2.076.294a2.138,2.138,0,0,0,1.8-.584l1.507-1.457a.725.725,0,0,1,1.012,0L31.426,26.6a2.138,2.138,0,0,0,1.8.584l2.076-.294a.725.725,0,0,1,.819.6l.362,2.065a2.138,2.138,0,0,0,1.111,1.529l1.852.982a.725.725,0,0,1,.313.963l-.921,1.883a2.138,2.138,0,0,0,0,1.89l.921,1.883A.725.725,0,0,1,39.443,39.642Z",
    fill: "#EA9B45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M33.787,29.756a.712.712,0,0,0-1.007,0l-9.4,9.4a.712.712,0,1,0,1.007,1.007l9.4-9.4A.712.712,0,0,0,33.787,29.756Z",
    transform: "translate(0.829 0.893)",
    fill: "#EA9B45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M25.742,30.024a2.61,2.61,0,1,0,2.61,2.61A2.613,2.613,0,0,0,25.742,30.024Zm0,3.8a1.186,1.186,0,1,1,1.186-1.186A1.188,1.188,0,0,1,25.742,33.82Z",
    transform: "translate(0.822 0.963)",
    fill: "#EA9B45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M30.7,35.294a2.61,2.61,0,1,0,2.61,2.61A2.613,2.613,0,0,0,30.7,35.294Zm0,3.8A1.186,1.186,0,1,1,31.891,37.9,1.188,1.188,0,0,1,30.7,39.091Z",
    transform: "translate(1.556 1.743)",
    fill: "#EA9B45"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.a12390f0.svg";
export { ForwardRef as ReactComponent };